module.exports = __webpack_public_path__ + "static/media/Image_OB_Daily.9dfed581.png";